<div class="toolbar">
  <mat-form-field class="me-2">
    <mat-label>Unit</mat-label>
    <input
      type="text"
      matInput
      placeholder="Select a Unit"
      [matAutocomplete]="unitAuto"
      [formControl]="unitCtrl"
    />
    <mat-autocomplete
      #unitAuto="matAutocomplete"
      (optionSelected)="selectUnit($event)"
    >
      @if (filteredUnits.length > 0) {
        @for (unit of filteredUnits; track unit.id) {
          <mat-option [value]="unit.id">
            {{ unit.id }}: {{ unit.name }}
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Solution</mat-label>
    <mat-select
      [(ngModel)]="solution"
      (selectionChange)="solutionChange($event)"
    >
      @for (sltn of solutions; track sltn.value) {
        <mat-option [value]="sltn.value">
          {{ sltn.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="ms-2">
    <mat-label>Date Range</mat-label>
    <mat-date-range-input [rangePicker]="pickerField">
      <input
        matStartDate
        placeholder="After"
        [(ngModel)]="dateRange.start"
        (dateChange)="dateChange($event, 'start')"
      />
      <input
        matEndDate
        placeholder="Before"
        [(ngModel)]="dateRange.end"
        (dateChange)="dateChange($event, 'end')"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="pickerField" />
    <mat-date-range-picker #pickerField />
  </mat-form-field>
</div>
